<template>
  <div class="g-head">
    <div class="g-head-content">
      <div class="content-l">
        <img src="@assets/img/icmefEn.png" @click="$router.push('/homeEn');" /> 
      </div>
      <div class="content-c"> 
      </div>
      <div class="content-r"> 
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "g-head",
  data() {
    return {
      searchType: 0, // 0 找产品，1 找展商
      proText: "",
      exText: "",
    }
  },
  computed: {
    ...mapGetters({
      searchContent: "exhibitor/getSearchContent",
    })
  },
  watch: {
    searchContent(val, oldVal) {
      if(val == "") {
        this.proText = "";
        this.exText = "";
      }
    }
  },
  methods: {
    ...mapMutations({
      setSearchType: "exhibitor/setSearchType",
      setSearchContent: "exhibitor/setSearchContent",
    }),
    search() {
      this.$router.push("/ex-listEn");
      if (this.searchType == 0) {
        this.setSearchType(0);
        this.setSearchContent(this.proText);
      } else {
        this.setSearchType(1);
        this.setSearchContent(this.exText);
      }
    },
    switchSearch(e) { 
      this.searchType = e;
    }
  },
};
</script>

<style lang="scss" scoped>
.g-head {
  width: 100%;
  height: 150px;
  background: #fff; 
	box-shadow: 0px 0px 6px 0px 
		rgba(8, 8, 8, 0.2);
  &-content {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .content-l { 
      height: 100%;
      display: flex;
      align-items: center;
      img {
        width: 200px;
        height: auto;
        cursor: pointer;
        margin-top: 10px;
        margin-left: -45px;
        cursor: pointer;
      } 
    }
    .content-c {
      padding-top: 32px;
      &-top {
        width: 100%;
        span {
          display: inline-block;
          width: 56px;
          height: 28px;
          color: #4d4d4d;
          font-size: 12px;
          text-align: center;
          line-height: 28px;
          cursor: pointer;
        }
        .active {
          background-color: #024c8b;
          color: #fff;
        }
      }
      &-bottom {
        display: flex;
        input {
          width: 264px;
          height: 32px;
          border: solid 1px #024c8b;
          outline: none;
          padding: 0 50px 0 10px;
          background-color: #fff;
        }
        ::-webkit-input-placeholder {
          /* Chrome/Opera/Safari */
          color: #ccc;
          font-size: 12px;
        }
        ::-moz-placeholder {
          /* Firefox 19+ */
          color: #ccc;
          font-size: 12px;
        }
        :-ms-input-placeholder {
          /* IE 10+ */
          color: #ccc;
          font-size: 12px;
        }
        :-moz-placeholder {
          /* Firefox 18- */
          color: #ccc;
          font-size: 12px;
        }
        span {
          display: inline-block;
          width: 56px;
          height: 32px;
          background-color: #024c8b;
          font-size: 12px;
          color: #fff;
          line-height: 32px;
          text-align: center;
          cursor: pointer;
        }
      }
    }
    .content-r {
      height: 100%;
      padding-top: 32px;
      p {
        width: 124px;
        height: 32px;
        background-color: #024c8b;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        color: #fff;
        cursor: pointer;
      }
      p:first-child {
        margin-bottom: 4px;
      }
    }
  }
}
</style>